import { isLogoutOnAuthFailureForced } from '@/lib/api-client/auth-failure-override'
import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'
import { useAuthStore } from '@/stores/auth'

const LOGOUT_PATH = '/logout'
const SILENT_SIGNOUT_PATH_PREFIXES = [
  '/review/',
  '/badge',
  '/sign-mark/',
  '/verify',
]

function readStoredAccessToken(serialized: string | null): string | null {
  if (!serialized) {
    return null
  }

  try {
    const parsed = JSON.parse(serialized) as {
      state?: { accessToken?: unknown }
    }
    return typeof parsed.state?.accessToken === 'string'
      ? parsed.state.accessToken
      : null
  } catch {
    return null
  }
}

function isSilentSignoutPage(pathname: string): boolean {
  return SILENT_SIGNOUT_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  )
}

export function subscribeToCrossTabAuth(): () => void {
  const handleStorage = (event: StorageEvent) => {
    if (event.key !== null && event.key !== LOCAL_STORAGE_KEYS.AUTH) {
      return
    }

    const storedAccessToken =
      event.key === null ? null : readStoredAccessToken(event.newValue)

    if (storedAccessToken) {
      void useAuthStore.persist.rehydrate()
      return
    }

    const { pathname } = window.location
    if (!useAuthStore.getState().accessToken || pathname === LOGOUT_PATH) {
      return
    }

    if (isLogoutOnAuthFailureForced()) {
      window.location.assign(LOGOUT_PATH)
      return
    }

    if (isSilentSignoutPage(pathname)) {
      useAuthStore.getState().clearAuth()
      return
    }

    window.location.assign(LOGOUT_PATH)
  }

  window.addEventListener('storage', handleStorage)
  return () => window.removeEventListener('storage', handleStorage)
}
